module.exports = __webpack_public_path__ + "img/health-connect-app.2c5b238a.svg";